module.exports = __webpack_public_path__ + "static/img/DGCX.b9439a27.png";